import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { rSetAppointment, rSetCategory } from "../../redux/reducers/GlobalVariables";
import config from '../../services/config';
import Swal from "sweetalert2";
const Services = () => {
    //#region 
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [category, setCategory] = useState([]);

    const handleNavigate = async (id) => {
        dispatch(rSetCategory(id));
    
        const result = await Swal.fire({
            title: 'Choose View Type',
            text: 'How would you like to view the anatomy?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Full Body View',
            cancelButtonText: 'Category View',
            reverseButtons: true,
        });
    
        if (result.isConfirmed) {
            navigate('/threeDmodel'); // Full Body View
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            navigate('/anatomy'); // Category View
        }
    };

    const fetchActiveCategory = async () => {
        try {
            const res = await config.getActiveCategory();
            if (res.status === 200) {
                setCategory(res.data);
            }
            else {
                setCategory([]);
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        fetchActiveCategory();
    dispatch(rSetAppointment(false));

    }, []);

// console.log("appointment===")
    // useEffect(() => {
    //     // Dummy API response
    //     const data = [
    //         { categoryid: 4, categoryname: "POst-surgery rehab", order_number: 1 },
    //         { categoryid: 5, categoryname: "sports injury", order_number: 2 },
    //         { categoryid: 6, categoryname: "Avoiding surgery", order_number: 3 },
    //         { categoryid: 7, categoryname: "Sudden acute pain", order_number: 4 },
    //         { categoryid: 8, categoryname: "Chronic pains", order_number: 5 },
    //         { categoryid: 1, categoryname: "Breathing and other difficulties", order_number: 6 },
    //         { categoryid: 3, categoryname: "sports performance enhancement", order_number: 7 }
    //     ];

    //     setCategory(data);
    // }, []);
    //#endregion

    
    return (
        <>
            <section className="services">
                <div className="container">
                    <div className="hexa">
                        <ul>
                            {
                                category.map((item, index) => (
                                    <li key={index} onClick={()=> handleNavigate(item.categoryid)}>
                                        <div className="flip-card-inner">
                                            <div className="flip-card-front">
                                                <h3>{item.categoryname}</h3>
                                            </div>
                                            <div className="flip-card-back">
                                                <h3>{item.categoryname}</h3>
                                            </div>
                                        </div>
                                    </li>
                                ))
                            }
                            {/* <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">                                        
                                        <h3>Anatomy Option1</h3>
                                    </div>
                                    <div className="flip-card-back">
                                        <h3>Anatomy Option2</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option2</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option2</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option3</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option3</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option4</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option4</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option5</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option5</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option6</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option6</h3>
                                    </div>
                                </div>
                            </li>
                            <li onClick={handleNavigate}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                    <h3>Anatomy Option7</h3>
                                    </div>
                                    <div className="flip-card-back">
                                    <h3>Anatomy Option7</h3>
                                    </div>
                                </div>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </section>
        </>
    )
}

export default memo(Services);
